import { SeoResponse, SettingResponse } from '../dto/ResDtoRepository';
import { UpdateGuideVisitReq, UpdateNotificationReq, UpdateSeoReq, UpdateSettingReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


//get해오는 것도 authToken 필요!!! => 아니!! 필요없다!!!
export const getSetting = async (aui: string): Promise<SettingResponse> => {
  return sendGetApiRequest<SettingResponse>(`/api/v1/setting?aui=${aui}`);
};

export const getSeo = async (aui: string): Promise<SeoResponse> => {
  return sendGetApiRequest<SeoResponse>(`/api/v1/setting/seo?aui=${aui}`);
};

export const updateSetting = async (aui: string, data: UpdateSettingReq): Promise<SettingResponse> => {
  return sendApiRequest<SettingResponse>('put', `/api/v1/setting?aui=${aui}`, data);
};

export const updateSeo = async (aui: string, data: UpdateSeoReq): Promise<SettingResponse> => {
  return sendApiRequest<SettingResponse>('put', `/api/v1/setting/seo?aui=${aui}`, data);
};

export const updateGuideVisit = async (aui: string, data: UpdateGuideVisitReq): Promise<SettingResponse> => {
  return sendApiRequest<SettingResponse>('put', `/api/v1/setting/guide?aui=${aui}`, data);
};

export const updateNotification = async (aui: string, data: UpdateNotificationReq): Promise<SettingResponse> => {
  return sendApiRequest<SettingResponse>('put', `/api/v1/setting/notification?aui=${aui}`, data);
};